export default theme => ({
  selected: {
    backgroundColor: theme.palette.primary.serena,
  },
  textGray: {
    opacity: 0.6,
  },
});
